import { cn } from 'src/lib/utils';
import type { SyncStatus } from '../types/campaigns.types';

interface SyncStatusIndicatorProps {
  status: SyncStatus;
  label: string;
}

const STATUS_CONFIG: Record<SyncStatus, { text: string; className: string }> = {
  synced: {
    text: '✓ synced',
    className: 'text-[#059669]',
  },
  failed: {
    text: '✗ failed',
    className: 'text-[#DC2626]',
  },
  pending: {
    text: '— pending',
    className: 'text-[#9CA3AF]',
  },
};

export function SyncStatusIndicator({ status, label }: SyncStatusIndicatorProps) {
  const config = STATUS_CONFIG[status];

  return (
    <span
      className={cn('text-[13px] font-medium', config.className)}
      aria-label={`${label}: ${status}`}
    >
      {config.text}
    </span>
  );
}
